type DateInput = string | number | Date | null | undefined;

function ordinal(n: number): string {
  const suffixes = ["th", "st", "nd", "rd"];
  const v = n % 100;
  return n + (suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]);
}

export function ensureUtc(value: string): string {
  return /(?:Z|[+-]\d{2}:?\d{2})$/.test(value) ? value : `${value}Z`;
}

function toDate(value: DateInput): Date {
  if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}/.test(value) && !/[zZ]|[+-]\d{2}:?\d{2}$/.test(value)) {
    return new Date(ensureUtc(value.replace(" ", "T")));
  }
  return new Date(value as string | number | Date);
}

export function timeAgo(value: DateInput): string | null {
  if (!value) return null;
  const ms = toDate(value).getTime();
  if (Number.isNaN(ms)) return null;
  const diff = Math.floor((Date.now() - ms) / 1000);
  if (diff < 60) return `${diff}s ago`;
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86_400) return `${Math.floor(diff / 3600)}h ago`;
  return `${Math.floor(diff / 86_400)}d ago`;
}

export function formatTime(value: DateInput): string {
  if (!value) return "";
  return toDate(value).toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function formatDateTime(value: DateInput): string {
  if (!value) return "";
  const date = toDate(value);
  const month = date.toLocaleDateString("en-GB", { month: "long" });
  return `${month} ${ordinal(date.getDate())} ${date.getFullYear()} - ${formatTime(value)}`;
}

export function getDateGroupLabel(value: DateInput, reference: Date): string {
  if (!value) return "";
  const date = toDate(value);
  const dayStart = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate());
  const diffDays = Math.round(
    (dayStart(reference).getTime() - dayStart(date).getTime()) / 86_400_000,
  );
  if (diffDays <= 0) return "Today";
  if (diffDays === 1) return "Yesterday";
  if (diffDays < 7) return date.toLocaleDateString("en-GB", { weekday: "long" });
  const month = date.toLocaleDateString("en-GB", { month: "long" });
  return `${month} ${ordinal(date.getDate())} ${date.getFullYear()}`;
}
